module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-09.57de2e85.png";